import future1 from ".././assets/future1.webp"
import future2 from ".././assets/future2.webp"
import future3 from ".././assets/future3.webp"
import future4 from ".././assets/future4.webp"
import future5 from ".././assets/future5.webp"

export const future_plans_slides =[
    future1,future2,future3,future4,future5
]